
import * as handlebars_family from "../handlebars_family.ts";
import "../layout/layout_modal.mustache";
const TPL = handlebars_family.addTemplate("calendar/aiimport_processing",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"modal V4 aiimport-processing\"><icon class=\"modal-close\" data-fw-onclick=\"modalclose\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_close",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":123},"end":{"line":1,"column":145}}}))
    + "</icon><flexcol class=\"content\"><div class=\"aiimport-scan\"> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"thumbnail") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data,"loc":{"start":{"line":1,"column":205},"end":{"line":1,"column":300}}})) != null ? stack1 : "")
    + " <div class=\"aiimport-scan-line\"></div></div><p class=\"aiimport-stage\">"
    + container.escapeExpression(lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"stage") : depth0),{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":371},"end":{"line":1,"column":385}}}))
    + "</p><button class=\"secondary\" data-fw-onclick=\"modalclose\">"
    + container.escapeExpression(lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"aiimport.continuebackground",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":444},"end":{"line":1,"column":482}}}))
    + "</button></flexcol></div> ";
},"2":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <img src=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"thumbnail") : depth0), depth0))
    + "\" alt=\"\"> ";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <icon>"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"icon") : depth0), depth0)) != null ? stack1 : "")
    + "</icon> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"layout/layout_modal"),depth0,{"name":"layout/layout_modal","fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " ";
},"usePartial":true,"useData":true});
export default TPL;